import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { OgrafService } from '../../services/ograf/OgrafService';
export function OgrafTrackCard({ graphic, cardWidth, cardHeight, highlighted, onClick, onDragStart, }) {
    const isPlaying = graphic.state === 'playing';
    const isReady = graphic.state === 'ready' || graphic.state === 'stopped';
    const isError = graphic.state === 'error';
    return (_jsxs(CardRoot, { "$cardWidth": cardWidth, draggable: onDragStart !== undefined, onDragStart: onDragStart, onClick: onClick, children: [_jsx(ThumbnailArea, { "$highlighted": highlighted, "$cardHeight": cardHeight, children: isError ? (_jsx(ErrorOverlay, { children: _jsx(ErrorText, { children: graphic.error || 'Error' }) })) : (_jsx(StatusBadge, { "$playing": isPlaying, children: isPlaying ? 'LIVE' : graphic.state })) }), _jsxs(NameRow, { children: [_jsx(OgrafIconSmall, {}), _jsx(GraphicName, { children: graphic.name })] }), _jsxs(ControlRow, { children: [_jsx(ControlButton, { disabled: !isReady && !isPlaying, "$active": isPlaying, onClick: (e) => {
                            e.stopPropagation();
                            if (isPlaying) {
                                OgrafService.getNotificationInterface().notifyStopGraphic(graphic.id);
                            }
                            else {
                                OgrafService.getNotificationInterface().notifyPlayGraphic(graphic.id);
                            }
                        }, children: isPlaying ? _jsx(StopIconSvg, {}) : _jsx(PlayIconSvg, {}) }), _jsx(ControlButton, { onClick: (e) => {
                            e.stopPropagation();
                            OgrafService.getNotificationInterface().notifyRemoveOgrafGraphic(graphic.id);
                        }, children: _jsx(RemoveIconSvg, {}) })] })] }));
}
function PlayIconSvg() {
    return (_jsxs("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", children: [_jsx("title", { children: "Play" }), _jsx("path", { d: "M3 1.5v9l7.5-4.5L3 1.5z", fill: "currentColor" })] }));
}
function StopIconSvg() {
    return (_jsxs("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", children: [_jsx("title", { children: "Stop" }), _jsx("rect", { x: "2", y: "2", width: "8", height: "8", rx: "1", fill: "currentColor" })] }));
}
function RemoveIconSvg() {
    return (_jsxs("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", children: [_jsx("title", { children: "Remove" }), _jsx("path", { d: "M3 3l6 6M9 3l-6 6", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" })] }));
}
function OgrafIconSmall() {
    return (_jsxs("svg", { width: "14", height: "14", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("title", { children: "OGraf graphic" }), _jsx("rect", { x: "2", y: "3", width: "16", height: "14", rx: "2", stroke: "currentColor", strokeWidth: "1.5" }), _jsx("path", { d: "M2 13h16", stroke: "currentColor", strokeWidth: "1.5" }), _jsx("rect", { x: "4", y: "14.5", width: "5", height: "1.5", rx: "0.75", fill: "currentColor" })] }));
}
const CardRoot = styled.div `
    flex-shrink: 0;
    width: ${({ $cardWidth }) => $cardWidth}px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    transition: transform 100ms ease;

    &:hover {
        transform: scale(1.02);
    }
`;
const ThumbnailArea = styled.div `
    position: relative;
    width: 100%;
    height: ${({ $cardHeight }) => $cardHeight}px;
    border-radius: 8px;
    overflow: hidden;
    background: rgba(30, 30, 40, 0.8);
    border: 2px solid
        ${({ $highlighted }) => $highlighted
    ? 'var(--tv-ui-color-13, #7B61FF)'
    : 'rgba(255, 255, 255, 0.12)'};
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
`;
const StatusBadge = styled.span `
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    padding: 2px 8px;
    border-radius: 4px;
    background: ${({ $playing }) => $playing ? 'rgba(255, 60, 60, 0.7)' : 'rgba(255, 255, 255, 0.15)'};
    color: rgba(255, 255, 255, 0.9);
`;
const ErrorOverlay = styled.div `
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
`;
const ErrorText = styled.span `
    font-size: 11px;
    color: rgba(255, 100, 100, 0.9);
    text-align: center;
`;
const NameRow = styled.div `
    display: flex;
    align-items: center;
    gap: 0.375rem;
    padding: 0.25rem 0.375rem 0;
    color: rgba(255, 255, 255, 0.85);
`;
const GraphicName = styled.span `
    font-size: 0.8125rem;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.25rem;
`;
const ControlRow = styled.div `
    display: flex;
    gap: 4px;
    padding: 2px 4px 0;
`;
const ControlButton = styled.button `
    flex: 1;
    height: 24px;
    border-radius: 6px;
    border: none;
    background: ${({ $active }) => $active ? 'rgba(255, 60, 60, 0.4)' : 'rgba(255, 255, 255, 0.1)'};
    color: rgba(255, 255, 255, 0.8);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    transition:
        background 100ms ease,
        color 100ms ease;

    &:hover:not(:disabled) {
        background: ${({ $active }) => $active ? 'rgba(255, 60, 60, 0.6)' : 'rgba(255, 255, 255, 0.2)'};
        color: white;
    }

    &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
    }
`;
